<template>
  <div style="padding:20px; height: 80%; width: 100%;box-sizing: border-box;">
    <el-row>
      <el-date-picker
        v-model="xzshijian"
        type="week"
        format="yyyy 第 WW 周"
        placeholder="选择周"
        style="width:180px;margin-right:10px;"
        @change="sjselext"
      ></el-date-picker>
      <span style="color:green">
        <span>{{this.startT}}</span> 至
        <span>{{this.endT}}</span>
      </span>
      <el-select v-model="xzproject" placeholder="请选择" style="margin-left:20px;" @change="xmselect">
        <el-option
          v-for="item in projectList"
          :key="item.project_id"
          :label="item.project_name_cn"
          :value="item.project_id"
        ></el-option>
      </el-select>
      <el-button type="primary" style="margin-left:20px;" @click="AddEmtyData">新增工作安排</el-button>
    </el-row>
    <div
      style="width:100%;font-size:30px;text-align: center;margin-top:30px"
    >{{xzprojectName}}——周任务分配表</div>
    <el-table
      :data="tableData"
      border
      style="width:100%; margin-top: 20px;"
      ref="multipleTable"
      height="100%"
    >
      <!-- check-->
      <!-- <el-table-column align="center" type="selection" width="40%"></el-table-column> -->
      <!-- 部门 -->
      <el-table-column prop="bumen" label="部门" align="center" width="160%">
        <template slot-scope="scope">
          <el-select
            size="small"
            @change="update(scope.row,scope.$index,$event,1)"
            v-model="scope.row.bumen"
          >
            <el-option
              v-for="item in departList"
              :label="item.depart_name"
              :value="item.depart_id"
              :key="item.depart_id"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="comments" label="内容" align="center" min-width="400%">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.comments"
            placeholder="请输入内容"
            size="small"
            @change="update(scope.row,scope.$index,$event)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="wctime" label="完成时间" align="center" width="200%">
        <template slot-scope="scope">
          <el-date-picker
            v-model="scope.row.comple_time"
            type="date"
            placeholder="选择日期"
            size="small"
            @change="update(scope.row,scope.$index,$event)"
            style="width:160px"
          ></el-date-picker>
        </template>
      </el-table-column>
      <el-table-column prop="wcper" label="完成人" align="center" width="200%">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.comple_employee_id"
            multiple
            placeholder="请选择"
            size="small"
            @change="update(scope.row,scope.$index,$event,2)"
          >
            <el-option
              v-for="item in scope.row.xiala"
              :key="item.employee_id"
              :label="item.employee_name"
              :value="item.employee_id"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="ysper" label="验收人" align="center" width="140%">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.ysper"
            placeholder="请选择"
            size="small"
            @change="update(scope.row,scope.$index,$event,3)"
          >
            <el-option
              v-for="item in scope.row.xiala"
              :key="item.employee_id"
              :label="item.employee_name"
              :value="item.employee_id"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>

      <el-table-column prop="ysper" label="是否完成" align="center" width="140%">
        <template slot-scope="scope">
          <div v-if="scope.row.is_palyed==1" style="color:green;">已完成</div>
          <div v-if="scope.row.is_palyed==0"></div>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="150%">
        <template slot-scope="scope">
          <el-button
            style="border: 0;background-color: transparent;outline: none;"
            @click="deleteRow(scope.row)"
          >
            <i class="el-icon-delete" style="color: red; font-size:16px"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getBaseInfo } from "@/api/user";
import axios from "axios";
import moment, { duration } from "moment";
import { getDays } from "@/lib/weektime";
export default {
  data() {
    return {
      tableData: [],
      departList: [],
      allemployee: [],
      zongdepart_person: [],
      projectList: [],
      xzproject: "", //选中项目ID
      xzprojectName: "", //选中项目name
      chushiPorject: "",
      xzshijian: "",
      startT: "",
      endT: "",
    };
  },
  created() {
    this.getBaseList();
  },
  methods: {
    getBaseList() {
      var chucunnowtime = JSON.parse(localStorage.getItem("zhou"));
      if (chucunnowtime && chucunnowtime != null) {
        this.xzshijian = chucunnowtime;
      } else {
        this.xzshijian = new Date();
      }
      //console.log(nowtime && nowtime != null);
      var nowtime = this.xzshijian;
      var getnowtime = getDays(nowtime);
      //console.log(getnowtime);
      this.startT = getnowtime[0];
      this.endT = getnowtime[3];
      getBaseInfo().then((res) => {
        //console.log(res);
        this.departList = res.depart_list;
        this.allemployee = res.employee_all_list;
        var getprojectList = res.project_list;
        for (let key in getprojectList) {
          if (key == 9 || key == 16) {
            delete getprojectList[key];
          }
        }
        var shuzugetprojectList = Object.values(getprojectList);
        axios
          .post(IPConfig.IP + "/kpi-management/qxgl/xmliebiao.php")
          .then((res) => {
            console.log(res.data.qx_result);
            let qxperson = res.data.qx_result;
            let uesrInfo = JSON.parse(localStorage.getItem("uesrInfo"));
            var roles = uesrInfo.qxianlist;
            console.log(uesrInfo.qxianlist);

            var shuzu = [];
            for (let key in qxperson) {
              if (qxperson[key].employee_id == uesrInfo.employee_id) {
                //console.log(qxperson[key].project_id);
                let guide = qxperson[key].project_id.split(",");
                for (let key1 in guide) {
                  //console.log(guide[key1]);
                  for (let key2 in getprojectList) {
                    //console.log(getprojectList[key2]);
                    if (guide[key1] == key2) {
                      console.log(getprojectList[key2]);
                      shuzu.push(getprojectList[key2]);
                    }
                  }
                }
                //console.log(guide);
              }
            }
            //console.log(shuzu);
            for (let key in roles) {
              if (roles[key] == 7) {
                this.projectList = shuzugetprojectList;
              } else {
                this.projectList = shuzu;
              }
            }

            this.chushiPorject = this.projectList[0].project_id;
            this.xzprojectName = this.projectList[0].project_name_cn;
            this.getTable(this.departList, this.allemployee);
          });

        //console.log(shuzugetprojectList);
      });
    },
    //增加行
    AddEmtyData() {
      //console.log(this.getshuzu(this.depart_id));
      var v = {
        bumen: "",
        comments: "",
        comple_time: "",
        comple_employee_id: [],
        accpet_employee_id: "",
        ysper: "",
        wcper: [],
        xm_id: -1,
        projectid: this.xzproject,
      };
      this.tableData.push(v);
      this.$nextTick(() => {
        this.$refs.multipleTable.bodyWrapper.scrollTop = this.$refs.multipleTable.bodyWrapper.scrollHeight;
      });
    },
    //初始化获取数据
    getTable(departList, allemployee) {
      //console.log(this.startT);
      //console.log(this.endT);
      //console.log(this.xzproject);
      var porjectid = JSON.parse(localStorage.getItem("xiangmu"));
      if (porjectid && porjectid != null) {
        this.xzproject = JSON.parse(localStorage.getItem("xiangmu"));
      } else {
        this.xzproject = this.chushiPorject;
      }
      axios
        .post(IPConfig.IP + "/kpi-management/rwfp/rwpf_info.php", {
          startT: this.startT,
          endT: this.endT,
          porjectid: this.xzproject,
        })
        .then((res) => {
          //console.log(res);
          //console.log(res.data.Alldepart_person);
          this.zongdepart_person = res.data.Alldepart_person;
          var Alldepart_person = res.data.Alldepart_person;
          var jieguo = res.data.rw_result;
          //this.tableData = res.data.rw_result;
          var getList = [];

          // //console.log(this.tableData);
          jieguo.forEach((element) => {
            //console.log(element);
            //console.log(element.comple_employee_id);
            let guide = element.comple_employee_id.split(",");
            element.comple_employee_id = guide;
            element.wcper = [];
            //console.log(guide);

            for (let key in allemployee) {
              // console.log(key);
              if (element.accpet_employee_id == key) {
                element.ysper = allemployee[key].employee_name;
              }
              // for (let key2 in guide) {
              //   if (guide[key2] == key) {
              //     element.wcper.push(allemployee[key].employee_name);
              //   }
              // }
            }
            for (let key1 in departList) {
              //console.log(departList);
              if (element.depart_id == key1) {
                element.bumen = departList[key1].depart_name;
                for (let k in Alldepart_person)
                  if (key1 == k) {
                    element.xiala = Alldepart_person[k];
                  }
              }
            }
          });
          //console.log(jieguo);
          this.tableData = jieguo;
        });
    },
    //创建和更新数据
    update(row, rowindex, xlValue, column) {
      //column 1 代表部门  2代表完成人 3代表验收人
      if (column == 1) {
        this.tableData[rowindex].ysper = "";
        this.tableData[rowindex].wcper = [];
        this.tableData[rowindex].comple_employee_id = [];

        for (let key in this.departList) {
          if (xlValue == this.departList[key].depart_id) {
            this.tableData[rowindex].bumen = this.departList[key].depart_name;
          }
        }
        this.tableData[rowindex].depart_id = xlValue;
        for (let key in this.zongdepart_person) {
          if (xlValue == key) {
            this.tableData[rowindex].xiala = this.zongdepart_person[key];
          }
        }
      }

      if (column == 2) {
        let departPerList = this.tableData[rowindex].xiala;
        var wcList = [];
        for (let key in departPerList) {
          for (let key1 in xlValue) {
            if (xlValue[key1] == departPerList[key].employee_id) {
              wcList.push(departPerList[key].employee_name);
            }
          }
        }
        //console.log(wcList);

        //this.tableData[rowindex].wcper = wcList;
        this.tableData[rowindex].comple_employee_id = xlValue;
      }
      if (column == 3) {
        let departPerList2 = this.tableData[rowindex].xiala;
        //console.log(departPerList2);
        //console.log(xlValue);
        for (let key in departPerList2) {
          if (xlValue == departPerList2[key].employee_id) {
            this.tableData[rowindex].ysper = departPerList2[key].employee_name;
          }
        }
        this.tableData[rowindex].accpet_employee_id = xlValue;
      }
      // console.log(row);
      // console.log(rowindex);
      // console.log(xlValue);

      //console.log(this.xzshijian);
      var xyzhi = this.tableData[rowindex];
      console.log(this.tableData[rowindex]);

      if (xyzhi.xm_id && xyzhi.xm_id != -1) {
        if (column == 2) {
          var crwcid = xyzhi.comple_employee_id;
        } else {
          var crwcid = [];
        }
        var xmid = this.tableData[rowindex].xm_id;
        //传入项目ID是更新
        axios
          .post(IPConfig.IP + "/kpi-management/rwfp/update.php", {
            departId: xyzhi.depart_id,
            comments: xyzhi.comments,
            wcid: crwcid,
            wctime: xyzhi.comple_time,
            ysid: xyzhi.accpet_employee_id,
            xmid: xmid,
            projectid: this.xzproject,
          })
          .then((res) => {});
      } else if (
        xyzhi.bumen != "" &&
        xyzhi.depart_id != "" &&
        xyzhi.comments != "" &&
        xyzhi["comple_employee_id"].length > 0 &&
        xyzhi.comple_time != "" &&
        xyzhi.accpet_employee_id != ""
      ) {
        axios
          .post(IPConfig.IP + "/kpi-management/rwfp/create.php", {
            departId: xyzhi.depart_id,
            comments: xyzhi.comments,
            wcid: xyzhi.comple_employee_id,
            wctime: xyzhi.comple_time,
            ysid: xyzhi.accpet_employee_id,
            flag: xyzhi.xm_id,
            projectid: this.xzproject,
            selectime: this.xzshijian,
          })
          .then((res) => {
            // console.log(xyzhi);
            this.tableData[rowindex].xm_id = res.data.clxmid;
            console.log(this.tableData[rowindex]);
          });
      }
    },
    //改变项目
    xmselect() {
      console.log(this.xzproject);
      var xiangmuId = this.xzproject;
      localStorage.setItem("xiangmu", JSON.stringify(xiangmuId));
      //console.log(this.projectList);
      for (let key in this.projectList) {
        if (this.xzproject == this.projectList[key].project_id) {
          this.xzprojectName = this.projectList[key].project_name_cn;
        }
      }

      this.getTable(this.departList, this.allemployee);
    },
    //改变时间
    sjselext() {
      //console.log(this.xzshijian);
      var nowtime = this.xzshijian;
      localStorage.setItem("zhou", JSON.stringify(nowtime));
      var getnowtime = getDays(nowtime);
      // console.log(getnowtime);
      this.startT = getnowtime[0];
      this.endT = getnowtime[3];
      this.getTable(this.departList, this.allemployee);
      // this.xzshijian = [getnowtime[0],getnowtime[3]]
    },
    deleteRow(e) {
      // this.open(e);
      // open(e) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          axios
            .post(IPConfig.IP + "/kpi-management/rwfp/delete.php", {
              xmid: e.xm_id,
            })
            .then((res) => {
              this.getTable(this.departList, this.allemployee);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
      // },
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/xmbg.vue